export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const UNKNOWN = 'UNKNOWN';
